import { environment } from "../environments/environment";

export const BASE_LMSA_URL = 'inspirenetz-api/';
export const BASE_ANALYTICS_URL = 'mysql/';

// LOC
// export const DEFAULT_MERCHANT_NO = '10';

// akasa and indigo merchant no
export const DEFAULT_MERCHANT_NO = environment.DEFAULT_MERCHANT_NO;

// Set the server root for INSP PROD
// export const SERVER_RESOURCES_ROOT = "https://portal.inspirenetz.com/in-resources";

// Set the server root for INSP STAGING
export const SERVER_RESOURCES_ROOT = environment.IMAGE_BASE_URL;

// Set the server root for CREDEZE UAT
// export const SERVER_RESOURCES_ROOT = "https://credeze-uat.inspirenetz.com/in-resources";
// export const DEFAULT_MERCHANT_NO = '57'

//image source for ADL DEV Eks
// export const SERVER_RESOURCES_ROOT = 'https://adl-dev-eks.inspirenetz.com/in-resources'

// LOC DEV
// export const IMAGE_BASE_URL = 'https://portal.inspirenetz.com/in-resources';

// Akasa image url
export const IMAGE_BASE_URL = environment.IMAGE_BASE_URL;

// dev-strapi
// export const ORDER_IMAGE_ROOT = 'https://dev-strapi-ecom.staging.inspirenetz.com'

// credeze-uat
// export const ORDER_IMAGE_ROOT = 'https://credeze-uat-cms.inspirenetz.com'

export const ORDER_IMAGE_ROOT = environment.ORDER_IMAGE_ROOT_URL;

// Airline
export const ACTIVE_AIRLINE = environment.ENV_AIRLINE; // "AKASA" , We can change locally also

export const AIRLINE = {
    "MALINDO" : {
        "CUSTOMER_OVERVIEW_WITH_DETAIL" : true,
        "RWD_CURRENCY_BASE_DATE_AND_MULTI_BASE_CURRENCY": false,
    },
    "AKASA" : {
        "CUSTOMER_OVERVIEW_WITH_DETAIL" : true,
    },
    "LION" : {
        "CUSTOMER_OVERVIEW_WITH_DETAIL" : true,
        "REWARD_CURRENCY_MULTI_BASE": true
    },
    "REX" : {
        "CUSTOMER_OVERVIEW_WITH_DETAIL" : true,
    },
    "INDIGO" : {
        "CUSTOMER_OVERVIEW_WITH_DETAIL" : true,
    },
}

export function getAirlineConfig(value){
    let definedValue = AIRLINE[ACTIVE_AIRLINE][value]
    return definedValue == null ||  definedValue == undefined ? false : definedValue
}

export const REWARD_CURRENCY_REX = '6352';
export const REWARD_CURRENCY_STATUS = '6353';
export const REWARD_CURRENCY_FLIGHTS = '6354';

// CodedValue index constants
export const CDV_INDEX_USER_TYPE = '1';
export const CDV_INDEX_ID_TYPE = '4';
export const SET_CRM_NOMINEE_INFORMATION_TAB_SHOW='4';
export const CDV_INDEX_CUSTOMER_SIGNUP_TYPE = '5';
export const CDV_INDEX_PAYMENT_MODES = '6';
export const CDV_INDEX_NOTIFICATION_TYPE = "8";
export const CDV_INDEX_COUNTRY_LIST = '14';
export const CDV_INDEX_REWARD_UNITS = '15';
export const CDV_INDEX_INCOME_RANGE = '18';
export const CDV_INDEX_PROFESSION = '19';
export const CDV_INDEX_CATALOGUE_PRODUCT_CATEGORY = "20";
export const CDV_INDEX_PROGRAM_DRIVER = '22';
export const CDV_INDEX_DAYS = "29";
export const CDV_INDEX_SPECIAL_OCCASIONS = "30";
export const CDV_INDEX_CURRENCY_CODES = '32';
export const CDV_INDEX_LOYALTY_PROGRAM_CHANNELS = "33";
export const CDV_INDEX_AGEGROUP_VALUES = '38';
export const CDV_INDEX_FAMILY_STATUS="39";
export const CDV_INDEX_CSG_DYNAMIC_CRITERIA_TYPE = "40";
export const CDV_INDEX_CRT_CARD_TYPES = "44";
export const CDV_INDEX_INDIA_STATE_LIST = "45";
export const CDV_INDEX_SECURITY_QUESTIONS = "48";
export const CDV_INDEX_TIER_EVALUATION_PERIOD = '50';
export const CDV_INDEX_TIER_COMPARISON_TYPE = '51';
export const CDV_LINK_CONFIG_LINKING_TYPE="52";
export const CDV_LINK_CONFIG_LINKING_ELIGIBILITY="53";
export const CDV_LINK_CONFIG_PRIMARY_ACCOUNT_ELIGIBILITY="54";
export const CDV_LINK_CONFIG_BUNDLING_ACTION_INITIATION="55";
export const CDV_LINK_CONFIG_BUNDLING_TIER_BEHAVIOUR="58";
export const CDV_BUNDLING_CONFIRMATION_TYPE="56";
export const CDV_BUNDLING_REDEMPTION_TYPE="57";
export const CDV_INDEX_CUSTOMER_TYPE = '59';
export const CDV_INDEX_MESSAGING_CHANNEL = '60';
export const CDV_INDEX_ATTRIBUTE_ENTITY="62";
export const CDV_INDEX_REDEMPTION_TYPE = "63";
export const CDV_INDEX_PASSWORD_PREFERENCES="65";
export const CDV_INDEX_REWARD_ACTIVITIES = '66';
export const CDV_INDEX_LOYALTY_TXN_TYPE = '67';
export const CDV_INDEX_ACTIVITIES = "69";
export const CDV_INDEX_REWARD_CURRENCY_EXPIRY = '70';
export const CDV_INDEX_REDEMPTION_CHANNELS = "71";
export const CDV_INDEX_TRANSFER_POINT_LINKED_ELIGIBILITY = "72";
export const CDV_INDEX_CUSTOMER_ROLES = '74';
export const CDV_INDEX_MORE = '75';
export const CDV_INDEX_BULK_UPLOAD_SYSTEM_VALUES="76";
export const CDV_INDEX_ROUNDING_METHOD = '78';
export const CDV_INDEX_TXN_SOURCES = '80';
export const CDV_INDEX_REM_TYPE = '81';
export const CDV_INDEX_REM_SETTLEMENT_LEVEL = '82';
export const CDV_INDEX_REM_SETTLEMENT_TYPE = '83';
export const CDV_INDEX_PARTNER_CATALOGUE_CATEGORY = '84';
export const CDV_INDEX_POINT_TIER_APPLICATION_TYPE ="86";
export const CDV_INDEX_POINT_TIER_BASE_CALCULATION ="87";
export const CDV_INDEX_POINT_TIER_TYPE = "88";
export const CDV_INDEX_CATALOGUE_EXTENSION_SECTORS = "89";
export const CDV_INDEX_CATALOGUE_EXTENSION_CABIN_CLASS = "90";
export const CDV_INDEX_CATALOGUE_SPECIFICATIONS = "92";
export const CDV_INDEX_SELLING_PERIOD = "93";
export const CDV_INDEX_REWARD_CURRENCY_DEBIT_PRIORITY = '94';
export const CDV_INDEX_RELATIONSHIP_TYPE = '95';
export const CDV_INDEX_DEPARTURE_INTERVAL="96";
export const CDV_INDEX_FARE_CALCULATION = "97";
export const CDV_INDEX_FARE_CLASS = "99";
export const CDV_INDEX_CUSTOMER_STATUS = '100';
export const CDV_MASTER_ENTITY_CONFIGURATION = '100';
export const CDV_MASTER_SERVICE_CONFIGURATION = '1001';
export const CDV_INDEX_ACCRUAL_STATUS = '102';
export const CDV_INDEX_PROMO_CATEGORIES = "109";
export const CDV_INDEX_CARD_DISCOUNT_TYPE = '106';
export const CDV_INDEX_REWARD_EXPIRY_DATE_SETTING = "108";
export const CDV_INDEX_CARD_NUMBER_ASSIGNMENT = '79';
export const SET_MERCHANT_PROFILE_360="144";

export const CDV_INDEX_SR_CATEGORIES = '101';
export const CDV_INDEX_SEGMENT_FIELD_DEFINITION_DATA_TYPE = "301";
export const CDV_INDEX_SEGMENT_FIELD_DEFINITION_INPUT_TYPE = "302";
export const SET_MER_ENABLE_CONSOLIDATE_BALANCE_VIEW = "211";
export const CDV_INDEX_SEGMENT_CRITERIA_AGGREGATE = "305";
export const CDV_INDEX_SEGMENT_COMPARATOR = "306";
export const CDV_INDEX_SEGMENT_PERIOD_TYPE = "307";
export const CDV_INDEX_SEGMENT_MEMBER_STATUS = "310";

export const SET_PROMO_EXTERNAL_LINK="185";
export const SET_MERCHANT_ENABLED_PROMO_ATTRIBUTE="207";
export const SET_MER_ACTIVE_LOCAL_CURRENCIES = "189";
export const CDV_INDEX_DISTRIBUTION_TYPE = "204";
export const SET_MER_CURRENCY_CODE = "212";
export const MER_WORKFLOW_ENABLED = "213";




export const SET_PROMO_ATTRIBUTE_CATEGORY='177';
export const SET_PROMO_ATTRIBUTE_BRAND='178';

// Function Codes
export const FNC_VOUCHER_UPDATE_REQUEST = '61';
export const FNC_SAVE_CASHBACK='105';
export const FNC_UPDATE_BRAND='135';
export const FNC_VIEW_PRINT_RECEIPT='207';
export const FNC_UPDATE_TRANSFER_POINT_REQUEST = '228'
export const FNC_UPDATE_SECURITY_SETTING='480';
export const FNC_ADJUST_REWARD_BALANCE='513';
export const FNC_UPDATE_CATALOGUE_DISPLAY_PREFERENCES = '1511';
export const FNC_UPDATE_VOUCHER='2554';
export const FNC_MERCHANT_CAMPAIGN_JOB_START =  '2686';
export const FNC_MERCHANT_SEGMENT_CRITERIA_REFRESH_JOB = '2687';
export const FNC_SHOW_CLAIM_BUTTON = '2714';
export const FNC_CUSTOMER_OVERVIEW_RESEND_ACTIVATION = '2721';
export const FNC_APPROVE_ACCRUAL = '2673';
export const FNC_VIEW_BUDGET_PROMO_EXTENSIONS = '2727';

//Date Constants

export const JS_SERVER_STANDARD_START_DATE = '1980-01-01';
export const JS_SERVER_STANDARD_END_DATE = '9999-12-31';

//LoyaltyProgram SKU Type constants
export const LPU_TYPE_BRAND = 1;
export const LPU_TYPE_PRODUCT_CATEGORY = 2;
export const LPU_TYPE_PRODUCT = 3;
export const LPU_TYPE_DT_BIRTHDAY = 4;
export const LPU_TYPE_DT_ANNIVERSARY = 5;
export const LPU_TYPE_CUSTOM_DATE = 6;
export const LPU_TYPE_SUBSCRIPTION = 7;
export const LPU_TYPE_EVENT_ENROLLMENT = 8;
export const LPU_TYPE_ACTIVITY = 9;
export const LPU_TYPE_PORTAL_DIALOGUE = 10;
export const LPU_TYPE_SPECIAL_BIRTHDAY = 12;

// export const SESSION_TIMEOUT_MS = 10 * 60 * 1000;

export const kotak_partner_no=9;

export const TXN_TYPE = {
    1: 'EARNING',
    2: 'REDEMPTION',
    3: 'EXPIRED',
    4: 'CASHBACK',
    5: 'LINKING TRANSFER TO',
    6: 'LINKING TRANSFER FROM',
    7: 'TRANSFER POINT TO',
    8: 'TRANSFER POINT FROM',
    9: 'BUY POINTS',
    10: 'REWARD ADJUSTMENT AWARDING',
    11: 'REWARD ADJUSTMENT DEDUCTING',
    12: 'TRANSFER ACCOUNT TO',
    13: 'TRANSFER ACCOUNT FROM',
    14: 'ACCOUNT DEACTIVATION',
    15: 'POINT REVERSAL',
    16: 'CHARGE CARD DEBIT',
    17: 'CHARGE CARD TOPUP',
    18: 'POINT EXCHANGE DEBIT',
    19: 'POINT EXCHANGE CREDIT'
};


export const ALL_COUNTRY = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1684"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1264"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Australia", "au", "61", "+.. ... ... ..."], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1242"], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32", "+.. ... .. .. .."], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1441"], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1284"], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", "+. (...) ...-....", 1], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", "", 1], ["Cayman Islands", "ky", "1345"], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86", "+.. ..-........"], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506", "+... ....-...."], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", "", 0], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45", "+.. .. .. .. .."], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1767"], ["Dominican Republic (República Dominicana)", "do", "1809"], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503", "+... ....-...."], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", "+... .. ... .. .."], ["France", "fr", "33", "+.. . .. .. .. .."], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49", "+.. ... ......."], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", "", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502", "+... ....-...."], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509", "+... ....-...."], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852", "+... .... ...."], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354", "+... ... ...."], ["India (भारत)", "in", "91", "+.. .....-....."], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353", "+... .. ......."], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39", "+.. ... ......"], ["Jamaica", "jm", "1876"], ["Japan (日本)", "jp", "81", "+.. ... .. ...."], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7", "+. ... ...-..-..", 1], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Macedonia (FYROM) (Македонија)", "mk", "389"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60", "+.. ..-....-...."], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1664"], ["Morocco (‫المغرب‬‎)", "ma", "212"], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31", "+.. .. ........"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64", "+.. ...-...-...."], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["Northern Mariana Islands", "mp", "1670"], ["Norway (Norge)", "no", "47", "+.. ... .. ..."], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92", "+.. ...-......."], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63", "+.. ... ...."], ["Poland (Polska)", "pl", "48", "+.. ...-...-..."], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1787"], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262"], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7", "+. ... ...-..-..", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy (Saint-Barthélemy)", "bl", "590", "", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Martin (Saint-Martin (partie française))", "mf", "590", "", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65", "+.. ....-...."], ["Sint Maarten", "sx", "1721"], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34", "+.. ... ... ..."], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Swaziland", "sz", "268"], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41", "+.. .. ... .. .."], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1649"], ["Tuvalu", "tv", "688"], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44", "+.. .... ......"], ["United States", "us", "1", "+. (...) ...-....", 0], ["U.S. Virgin Islands", "vi", "1340"], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "379"], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna", "wf", "681"], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"]];

// allCountries[i] = {
//     name: c[0],
//     iso2: c[1],
//     dialCode: c[2]
// };
